import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'ar', name: 'العربية' },
    { code: 'ch', name: '中文' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const changeLanguage = (langCode: string) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
    document.documentElement.dir = langCode === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = langCode;
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-white border border-gray-200 hover:border-gold/50 transition-all duration-300 cursor-pointer shadow-sm hover:shadow-md"
      >
        <i className="ri-global-line text-gold text-lg"></i>
        <span className="text-navy text-sm font-semibold">{currentLanguage.name}</span>
        <i className={`ri-arrow-down-s-line text-navy transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 right-0 bg-white rounded-lg shadow-xl border border-gray-100 overflow-hidden min-w-[140px] z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`w-full px-4 py-3 text-left hover:bg-gold/10 transition-colors duration-200 cursor-pointer flex items-center gap-3 ${
                i18n.language === lang.code ? 'bg-gold/5 text-gold' : 'text-gray-700'
              }`}
            >
              <span className="text-sm font-medium">{lang.name}</span>
              {i18n.language === lang.code && (
                <i className="ri-check-line text-gold ml-auto"></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}